import { useContext } from 'react';
import { AxiosResponse } from 'axios';
import { storeContext } from '../../store/store';
import { PendingAccount, ITinCertifcationAccountInfo } from '../../models';
import { useAxios, useConfig } from '../index';

const useNotifications = () => {
  const { state, dispatch } = useContext(storeContext);
  const { wealthConfig } = useConfig();
  const { investInstance: proxyInstance } = useAxios(
    wealthConfig.proxyUrl,
    true
  );

  const getPendingAccounts = async () => {
    const { data }: AxiosResponse<PendingAccount[]> =
      ((await proxyInstance('GET', `/notification/accounts/pending`).catch(
        (err: Error) => {}
      )) as AxiosResponse) || {};
    dispatch({ type: 'SET_PENDING_ACCOUNTS', payload: data || [] });
  };

  const suppressNotification = (notificationID: string) => {
    dispatch({
      type: 'SUPPRESS_NOTIFICATION',
      payload: notificationID,
    });
  };

  const submitDocumentAgreements = async (
    accountInformation: ITinCertifcationAccountInfo
  ) => {
    const response: AxiosResponse<{
      AccountId: string;
      AccountNumber: string;
      IsCancel: boolean;
      NewHouseholdId: string;
    }> =
      ((await proxyInstance('POST', `/notification/doc-agreements`, {
        data: accountInformation,
      }).catch((err: Error) => {})) as AxiosResponse) || {};
    if (response.data) {
      return response.data;
    }
    return null;
  };

  return {
    getPendingAccounts,
    pendingAccounts: state.appCache.pendingAccounts || [],
    suppressNotification,
    suppressedNotifications: state.appCache.suppressedNotifications || {},
    submitDocumentAgreements,
  };
};

export default useNotifications;
